import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-credit-card-icon',
  templateUrl: './credit-card-icon.component.html',
  styleUrls: ['./credit-card-icon.component.scss'],
})
export class CreditCardIconComponent implements OnInit {

  color: string = '#162A62';
  @Input() status: string;
  constructor() { }

  ngOnInit() {
    if (this.status == 'credit_card') {
      this.color = '#3B6CF8';
    } else {
      this.color = '#162A62';
    }
  }
}
